<template>
  <v-navigation-drawer
    v-if="items || $vuetify.breakpoint.mdAndDown"
    id="base-nav-drawer"
    :class="{'base-nav-drawer': true, 'devMode': devMode}"
    :clipped="false"
    app
    :miniVariant.sync="mini"
    :miniVariantWidth="50"
    touchless
    :value="drawer"
    color="#26384B"
    :style="[!mini ? { 'padding': '0px 10px' } : {}]"
    :floating="true"
    @input="onInput"
  >
    <v-row
      justify="center"
      style="margin: 15px 0px"
    >
      <!-- aquassist logo dashboard link -->
      <router-link
        id="navbar-brand"
        to="/dashboard"
        class="mb-2"
      >
        <img
          v-if="!mini"
          src="@/assets/images/aquassist_reverse.png"
          alt="Aquassist"
          height="58"
        >
        <div
          v-else
          class="d-flex justify-center align-center"
          style="padding: 5px; width: 100%; aspect-ratio: 1/1;"
        >
          <img
            src="@/assets/images/aquassist_logo_mini.png"
            alt="Aquassist"
            style="width: 30px; height: 30px"
          >
        </div>
      </router-link>
    </v-row>

    <v-btn
      class="drawer-toggle-btn"
      fab
      @click.stop="handleMiniChange"
    >
      <v-icon v-if="mini">
        mdi-chevron-right
      </v-icon>
      <v-icon v-else>
        mdi-chevron-left
      </v-icon>
    </v-btn>
    <!-- mini items when collapsed -->
    <div
      v-if="mini"
      style="display: flex"
    >
      <!-- The sidebar menu elements-->
      <v-list class="sidebar">
        <v-list-item
          v-for="item in miniItems"
          :key="item.title"
          :to="item.path"
          :disabled="isListItemDisabled(item)"
          :data-cy="nameMiniItemsDataCy(item)"
          v-on="item.path ? { click: ()=> onListItemClick(item) } : {}"
        >
          <v-list-item-content>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <img
                  v-if="item.icon"
                  width="15px"
                  height="15px"
                  class="filter--white"
                  :src="require(`@/assets/images/sidebar_icons/${item.icon}`)"
                  v-bind="attrs"
                  v-on="on"
                >
              </template>
              <span>{{ $t(item.title) }}</span>
            </v-tooltip>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
    <!-- full items when expanded -->
    <div v-else>
      <v-list-item v-if="title">
        <v-list-item-title class="sidebar-title">
          {{ title }}
        </v-list-item-title>
        <v-list-item-subtitle v-if="subtitle">
          {{ subtitle }}
        </v-list-item-subtitle>
      </v-list-item>
      <v-list class="sidebar">
        <div class="hidden-lg-and-up">
          <v-list-item
            v-for="item in mainNavItems"
            :key="item.path"
            :to="`${item.path}`"
          >
            <v-list-item-content>
              <v-list-item-title>
                <div class="d-flex">
                  <img
                    v-if="item.icon"
                    width="15px"
                    height="15px"

                    class="filter--white"
                    :src="require(`@/assets/images/sidebar_icons/${item.icon}`)"
                  >
                  <span class="name">{{ $t(item.title) }}</span>
                </div>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider
            v-if="items"
            class="mb-5"
          />
        </div>
        <v-expansion-panels
          v-if="hasCategories"
          :flat="true"
        >
          <v-expansion-panel
            v-for="(item, idx) in items"
            :key="idx"
          >
            <v-expansion-panel-header
              :data-cy="nameExpandableDataCy(item)"
            >
              <template v-slot:actions>
                <v-icon color="white">
                  $expand
                </v-icon>
              </template>
              <div class="d-flex">
                <img
                  v-if="item.icon"
                  width="15px"
                  height="15px"
                  class="filter--white"
                  :src="require(`@/assets/images/sidebar_icons/${item.icon}`)"
                >
                <span class="name">
                  {{ $t(item.title) }}
                </span>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <template v-for="categoryItem in item.categoryItems">
                <v-list-group
                  v-if="hasSubCategory(categoryItem)"
                  :key="categoryItem.title"
                  :value="true"
                  color="white"
                >
                  <template v-slot:activator>
                    <v-list-item-title :data-cy="`${dataCy.menuList.categoryItem}-${categoryItem.title}`">
                      {{ $t(categoryItem.title) }}
                    </v-list-item-title>
                  </template>
                  <template v-slot:appendIcon>
                    <v-icon color="white">
                      $expand
                    </v-icon>
                  </template>
                  <v-list-item
                    v-for="subCategoryItem in categoryItem.subCateggoryItems"
                    :key="subCategoryItem.title"
                    class="category-items"
                    :disabled="isListItemDisabled(subCategoryItem)"
                    :to="subCategoryItem.path"
                    :data-cy="nameSubCategoryDataCy(subCategoryItem)"
                  >
                    <v-list-item-title>
                      {{ $t(subCategoryItem.title) }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list-group>
                <template v-else>
                  <v-list-item
                    :key="categoryItem.title"
                    class="category-items"
                    :disabled="isListItemDisabled(categoryItem)"
                    :to="categoryItem.path"
                    :data-cy="nameCategoryDataCy(categoryItem)"
                  >
                    <v-list-item-title>
                      {{ $t(categoryItem.title) }}
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </template>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <div v-else>
          <v-list-item
            v-for="item in items"
            :key="item.title"
            :to="item.path"
            :disabled="isListItemDisabled(item)"
            :data-cy="nameForDataCy(item)"
            v-on="item.path ? { click: ()=> onListItemClick(item) } : {}"
          >
            <v-list-item-content>
              <div
                v-if="item.showItemNumber && activeOrders && activeOrders.products && activeOrders.products.length"
                class="order"
              >
                <div class="d-flex">
                  <img
                    v-if="item.icon"
                    width="15px"
                    height="15px"
                    class="filter--white"
                    :src="require(`@/assets/images/sidebar_icons/${item.icon}`)"
                  >
                  <span
                    class="name d-flex"
                    style="width: 100%;"
                  >
                    <v-list-item-title>
                      {{ $t(item.title) }}
                    </v-list-item-title>
                    <v-list-item-title class="itemNumber">
                      {{ activeOrders.products.length }}
                    </v-list-item-title>
                  </span>
                </div>
              </div>
              <div v-else>
                <v-list-item-title>
                  <div class="d-flex">
                    <img
                      v-if="item.icon"
                      width="15px"
                      height="15px"
                      class="filter--white"
                      :src="require(`@/assets/images/sidebar_icons/${item.icon}`)"
                    >
                    <span class="name">{{ $t(item.title) }}</span>
                  </div>
                </v-list-item-title>
              </div>
              <template v-for="itemcategory in item.categoryItems">
                <v-list-group
                  v-if="hasSubCategory(itemcategory)"
                  :key="itemcategory.title"
                  :value="true"
                >
                  <template v-slot:activator>
                    <v-list-item-title>{{ $t(itemcategory.title) }}</v-list-item-title>
                  </template>
                  <v-list-item
                    v-for="itemSubcategory in itemcategory.subCateggoryItems"
                    :key="itemSubcategory.title"
                    class="category-items"
                    :disabled="isListItemDisabled(itemSubcategory)"
                    :to="itemSubcategory.path"
                  >
                    <v-list-item-title>
                      {{ $t(itemSubcategory.title) }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list-group>
                <template v-else>
                  <v-list-item
                    :key="itemcategory.title"
                    class="category-items"
                    :disabled="isListItemDisabled(itemcategory)"
                    :to="itemcategory.path"
                  >
                    <v-list-item-title>
                      {{ $t(itemcategory.title) }}
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </template>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import navItems from '@/constants/navItems';
import { menuList } from '@/aq-data-cy.json';
import roleConstants from '@/utilities/enums/rolesTypes';

export default {
    props: {
        title: {
            type: String,
            default: null,
        },
        subtitle: {
            type: String,
            default: null,
        },
        items: {
            type: Array,
            default: null,
        },
        hasCategories: {
            type: Boolean,
            default: false,
        },
        initialMini: {
            type: Boolean,
            default: false,
        },
        inCalendar: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            mini: this.initialMini,
        };
    },
    computed: {
        ...mapGetters([
            'drawer',
            'roles',
            'hasRole',
            'activeOrders',
            'devMode',
        ]),
        mainNavItems() {
            return navItems.filter(item => item.roles.some(role => this.hasRole(role))).map(item => ({
                title: `${item.name}.pageName`,
                path: `/${item.name}`,
                icon: `${item.name}.svg`,
            }));
        },
        miniItems() {
            if (!this.items?.length) {
                return navItems.filter(item => item.roles.some(role => this.hasRole(role))).map(item => ({
                    title: `${item.name}.pageName`,
                    path: `/${item.name}`,
                    icon: `${item.name}.svg`,
                }));
            }
            return this.items;
        },
        dataCy() {
            return {
                menuList,
            };
        },
    },
    mounted() {
        const aquassistBillingItem = this.items ? this.items.find(item => item.title === 'administration.aquassistBilling') : null;
        if (this.hasRole(roleConstants.FINANCIALADMINISTRATOR) && aquassistBillingItem) {
            this.$router.push('/administration/aquassistBilling/billingRegister');
        }
        if (this.inCalendar) this.mini = true;
    },
    methods: {
        ...mapActions(['toggleDrawer', 'toggleMini']),
        onListItemClick(item) {
            if (!item.path && item.action) {
                this.$emit('click', item.action);
            }
        },
        isListItemDisabled(item) {
            if (item.categoryItems) return false;
            return !(item.path || item.action || item.isButton);
        },
        hasSubCategory(categoryItem) {
            return (categoryItem.subCateggoryItems?.length > 0);
        },
        onInput(open) {
            this.toggleDrawer(open);
        },
        handleMiniChange() {
            this.mini = !this.mini;
            this.toggleMini(this.mini);
        },
        nameForDataCy(item) {
            return `${this.dataCy.menuList.listItem}-${item.path?.name ? item.path.name : item.title}`;
        },
        nameSubCategoryDataCy(subCategoryItem) {
            return `${this.dataCy.menuList.subCategoryItem}-${subCategoryItem.path?.name ? subCategoryItem.path.name : subCategoryItem.title}`;
        },
        nameCategoryDataCy(categoryItem) {
            return `${this.dataCy.menuList.categoryItem}-${categoryItem.path?.name ? categoryItem.path.name : categoryItem.title}`;
        },
        nameExpandableDataCy(item) {
            return `${this.dataCy.menuList.expandable}-${item.title.split('.')[1]}`;
        },
        nameMiniItemsDataCy(item) {
            if (item.path?.name) {
                return `${this.dataCy.menuList.listItem}-${item.path?.name}`;
            }
            return `${this.dataCy.menuList.listItem}-${item.title.split('.')[1]}`;
        },
    },
};
</script>

<style lang="scss">
  @import "@/assets/styles/utils/_variables.scss";

  #base-nav-drawer {
    background: $primary-color;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.25);
    overflow: initial;
    .sidebar {
      padding-top: 0;
    }

    .sidebar-title {
      font-size: 14px;
      font-weight: 500;
    }

    .filter--white {
      // put svg in white
      filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%);
    }

    .v-btn--fab.v-size--default.drawer-toggle-btn {
      opacity: 0;
      z-index: 100;
      position: absolute;
      top: 0;
      right: -14px;
      bottom: 0;
      margin: auto;
      width: 28px;
      height: 28px;
      background: white;
      box-shadow: 0 2px 2px rgba(0, 0, 0, 0.25), 0 4px 4px rgba(0, 0, 0, 0.25);
      border: 2px solid $primary-color;
      border-radius: 50%;
    }

    .v-list-item__title {
      font-size: 14px;
      letter-spacing: 1.25px;
      color: white;
    }

    .category-items{
        margin-top:5px;
    }

    .v-list-item--active {
      background-color: rgba(255, 255, 255, 0.3);
      font-weight: bold;
      color: white;
      border-radius: 5px;
      margin-left: 1px;
    }
    .v-list-item--active::before {
      opacity: 1;
      background-color: transparent;
      border-left: 5px solid rgba(239, 65, 53, 0.8);
      border-radius: 5px;
    }
    .v-expansion-panel-header--active:before {
      opacity: 1;
      background-color: transparent;
      border-left: 5px solid rgba(239, 65, 53, 0.8);
      border-radius: 4px;
    }
    .theme--light.v-list-item--disabled {
      opacity: 0.3;
    }

    .v-expansion-panel-header {
      color: white;
      background: $primary-color;
    }

    .v-expansion-panel-content__wrap {
      padding: 0;
      background: $primary-color;
    }

    &:hover {
      .v-btn--fab.v-size--default.drawer-toggle-btn {
        opacity: 1;
      }
    }
    .v-list-item--active v-list-item v-list-item--link theme--light {
      border-radius: 9px;
    }
    .v-list-item__content {
     padding-bottom: 8px;
    justify-content: center;
    padding-top: 11px;
    padding-left: 3px
    }
    .order {
      .itemNumber {
        text-align: end;
        color: #EF4135;
        border-radius: 50%;
        background-color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        max-width: 25px;
        height: 25px;
        font-size: 13px;
      }
    }

    .name {
      padding-left: 20px;
      letter-spacing: 1.25px;
    }
}

  @media screen and (max-width: 960px) {
    #base-nav-drawer {
      height: 100%!important
    }
  }
</style>

<style scoped lang="scss">
  .devMode {
    margin-top: 20px;
  }
</style>
